import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"

import { GatewayManufacturedDeviceGeneralInfo } from "../app/models/Gateway"
import { digitalManagerApi } from "../services/api"

export function useGatewayManufacturedDevices() {
  const queryClient = useQueryClient()

  const { data: manufacturedDevicesList = [], isLoading: isLoadingManufacturedDevice } =
    useQuery({
      queryKey: ["gatewayManufacturedDevices"],
      queryFn: () =>
        digitalManagerApi
          .get<GatewayManufacturedDeviceGeneralInfo[]>(`/gateway/manufacturedDevices`)
          .then((r) => r.data),
    })

  const reloadManufacturedDevices = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ["gatewayManufacturedDevices"] }),
    [queryClient]
  )

  return {
    manufacturedDevicesList,
    isLoadingManufacturedDevice,
    reloadManufacturedDevices,
  }
}
